<h1 mat-dialog-title>Dati appuntamento</h1>
<div mat-dialog-content class="content">



    <mat-form-field appearance="fill" style="padding-right: 10px">
      <mat-label>Titolo*</mat-label>
      <input matInput [(ngModel)]="titolo">
    </mat-form-field>

    <mat-form-field appearance="fill" style="padding-right: 10px">
        <mat-label>Ora inizio*</mat-label>
        <input matInput [(ngModel)]="orainizio" type="time" placeholder="HH:MM" id="start_time_hour">
   </mat-form-field>

    <mat-form-field appearance="fill" style="padding-right: 10px">
        <mat-label>Ora fine*</mat-label>
            <input matInput type="time" [(ngModel)]="orafine" placeholder="HH:MM" id="end_time_hour">
   </mat-form-field>

   <mat-form-field appearance="fill" style="padding-right: 10px">
     <mat-label class="text-sm">Tipo</mat-label>
     <mat-select [(ngModel)]="selectedValueTipoevento" name="stato" class="text-sm">
       <mat-option *ngFor="let tipoevento of tipievento" [value]="tipoevento.Nome">
         {{tipoevento.Nome}}
       </mat-option>
     </mat-select>
   </mat-form-field>


  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="sel">
        <th mat-header-cell *matHeaderCellDef>Altro</th>
        <td mat-cell *matCellDef="let azienda">
          <mat-checkbox
            (click)="manageCheckboxclick($event, azienda)"
            (change)="$event ? selection.toggle(azienda) : null"
            [checked]="selection.isSelected(azienda)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="Codice">
          <th [style.display]="getConfigurazione().Codice" mat-header-cell *matHeaderCellDef> Nome
            <img src="./assets/images/sort.png" (click)="manageClick('Codice')"/>
          </th>
          <td [style.display]="getConfigurazione().Codice" mat-cell *matCellDef="let azienda"> {{azienda.Codice}} </td>
      </ng-container>

      <ng-container matColumnDef="Nome">
          <th [style.display]="getConfigurazione().Nome" mat-header-cell *matHeaderCellDef> Nome
            <img src="./assets/images/sort.png" (click)="manageClick('Nome')"/>
          </th>
          <td [style.display]="getConfigurazione().Nome" mat-cell *matCellDef="let azienda"> {{azienda.Nome}} </td>
      </ng-container>

      <ng-container matColumnDef="Partitaiva">
          <th [style.display]="getConfigurazione().Partitaiva" mat-header-cell *matHeaderCellDef> Partita IVA
            <img src="./assets/images/sort.png" (click)="manageClick('Partitaiva')"/>
          </th>
          <td [style.display]="getConfigurazione().Partitaiva" mat-cell *matCellDef="let azienda"> {{azienda.Partitaiva}} </td>
      </ng-container>

<!--
      <ng-container matColumnDef="Email">
          <th [style.display]="getConfigurazione().Email" mat-header-cell *matHeaderCellDef> email
            <img src="./assets/images/sort.png" (click)="manageClick('Email')"/>
          </th>
          <td [style.display]="getConfigurazione().Email" mat-cell *matCellDef="let azienda"> {{azienda.Email}} </td>
      </ng-container>
-->
      <ng-container matColumnDef="Email">
          <th [style.display]="getConfigurazione().Email" mat-header-cell *matHeaderCellDef> email
            <img src="./assets/images/sort.png" (click)="manageClick('Email')"/>
          </th>
          <td [style.display]="getConfigurazione().Email" mat-cell *matCellDef="let azienda">
            <input matInput value="{{azienda.Email}}" (keyup)="manageChangeEmail($event)">
          </td>
      </ng-container>

      <ng-container matColumnDef="Codicefiscale">
          <th [style.display]="getConfigurazione().Codicefiscale" mat-header-cell *matHeaderCellDef> Codice fiscale
            <img src="./assets/images/sort.png" (click)="manageClick('Codicefiscale')"/>
          </th>
          <td [style.display]="getConfigurazione().Codicefiscale" mat-cell *matCellDef="let azienda"> {{azienda.Codicefiscale}} </td>
      </ng-container>

      <ng-container matColumnDef="Ragionesociale">
          <th [style.display]="getConfigurazione().Ragionesociale" mat-header-cell *matHeaderCellDef> Ragione sociale
            <img src="./assets/images/sort.png" (click)="manageClick('Ragionesociale')"/>
          </th>
          <td [style.display]="getConfigurazione().Ragionesociale" mat-cell *matCellDef="let azienda"> {{azienda.Ragionesociale}} </td>
      </ng-container>
<!--
      <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Modifica </th>
          <td mat-cell *matCellDef="let azienda">
            <button (click)="editAzienda(azienda)" mat-dialog-close>
                <mat-icon color="primary">create</mat-icon>
            </button>
          </td>
      </ng-container>
      -->
<!--
      <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef> Seleziona </th>
          <td mat-cell *matCellDef="let azienda">
            <ng-container *ngIf="enableSave()">
              <mat-icon color="primary" [mat-dialog-close]='{codiceazienda: azienda.Codice, titolo: titolo, orainizio: orainizio, orafine: orafine}'>done</mat-icon>
            </ng-container>
          </td>
      </ng-container>
-->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

</div>
<div mat-dialog-actions>
  <!--
  <button mat-raised-button  color="primary" [mat-dialog-close]='data.user' (click)="addPersonaToUser()">Salva</button>
  <button mat-raised-button  color="primary" [mat-dialog-close]='data.user' (click)="removePersonaFromUser()">Dissocia</button>
  -->
  <button mat-raised-button  color="primary" mat-dialog-close >Cancella</button>
<!--  <button mat-raised-button [disabled]="!enableSave()"  color="primary" [mat-dialog-close]='{codiceazienda: azienda.Codice, nomeazienda: azienda.Nome, titolo: titolo, orainizio: orainizio, orafine: orafine}'>Salva</button>
-->
  <button mat-raised-button [disabled]="!enableSave()"  color="primary" [mat-dialog-close]='{azienda: azienda, titolo: titolo, orainizio: orainizio, orafine: orafine, tipoevento:selectedValueTipoevento}'>Salva</button>


</div>
